import { createAction, props } from '@ngrx/store';
import {
  DeliveriesResponseModel,
  DeliveryApiModel,
} from 'app/models/delivery-api.model';
import { MwLoadOptions } from 'app/models/load-options.model';

export const loadDeliveries = createAction(
  '[Deliveries] Load',
  props<{ loadOptions?: MwLoadOptions }>()
);

export const loadDeliveriesSuccess = createAction(
  '[Deliveries] Load Successful',
  props<{ response: DeliveriesResponseModel }>()
);

export const loadDeliveriesFailed = createAction(
  '[Deliveries] Load Failure',
  props<{ error: any }>()
);

export const loadDelivery = createAction(
  '[Deliveries] Load single',
  props<{ deliveryId: number }>()
);

export const loadDeliverySuccess = createAction(
  '[Deliveries] Load single Successful',
  props<{ delivery: DeliveryApiModel }>()
);

export const loadDeliveryFailed = createAction(
  '[Deliveries] Load single Failure',
  props<{ error: any }>()
);

export const createDelivery = createAction(
  '[Deliveries] Create',
  props<{ delivery: DeliveryApiModel }>()
);

export const createDeliverySuccess = createAction(
  '[Deliveries] Create Successful',
  props<{ delivery: DeliveryApiModel }>()
);

export const createDeliveryFailed = createAction(
  '[Deliveries] Create Failure',
  props<{ error: any }>()
);

export const updateDelivery = createAction(
  '[Deliveries] Update',
  props<{ delivery: DeliveryApiModel }>()
);

export const updateDeliverySuccess = createAction(
  '[Deliveries] Update Successful'
);

export const updateDeliveryFailed = createAction(
  '[Deliveries] Update Failure',
  props<{ error: any }>()
);

export const deleteDelivery = createAction(
  '[Deliveries] Delete',
  props<{ delivery: DeliveryApiModel }>()
);

export const deleteDeliverySuccess = createAction(
  '[Deliveries] Delete Successful'
);

export const deleteDeliveryFailed = createAction(
  '[Deliveries] Delete Failure',
  props<{ error: any }>()
);
